<template>
  <div class="flex-col justify-center items-start gap-4 flex max-w-[256px] w-full">
    <div class="flex gap-2">
      <v-field name="value" v-model="answer.data.number" v-slot="{field: veeField, errors}" :rules="{required}">
        <input
            :aria-label="` ${field.datahash.label};`"
            :name="`phonenumberfieldField-${field.id}`"
            class="tw-textinput"
            :class="{'tw-textinput-error': isInvalid}"
            :data-field-id="answerKey(answer)"
            @blur="setPresentationValue"
            @change="handleChange"
            @focus="handleFocus"
            v-bind="veeField"
            :placeholder="field.datahash.placeholder_number"
            :required="required"
            type="text">
      </v-field>

      <div class="input-with-prefix-block grow shrink">
        <div class="input-prefix">{{ $t('ext') }}</div>
        <input
            :aria-label="`${field.datahash.label} extension`"
            class="tw-textinput input-with-prefix"
            :data-field-id="answerKey(answer)"
            @change="handleChange"
            @focus="handleFocus"
            @blur="handleFocusOut"
            v-model="answer.data.extension"
            :placeholder="field.datahash.placeholder_extension"
            type="text">
      </div>
    </div>

    <errors :value="luaErrors[field.slug]" />
    <from-contact-sub-type :field="field" />
  </div>
</template>
<script>
import editMixin from './_mixin_edit.js'
import FromContactSubType from './_from_contact_sub_type.vue'
import {handleFocus, handleFocusOut, handleFocusOnChange, cacheAngularAnswers} from 'channels/form_result.js'

/**
 * Creates a presentation value.
 * e.g. (971) 258-0519
 * @param {String} value The value to perform the operation on.
 * @returns {String} The correctly formatted value.
 */
export const presentationValue = (value)=> {
  if(!value) return null
  const parts = value.match(/(\d{1})?(\d{3})(\d{3})(\d{4})/);
  if (!parts) return value; // Invalid format, return original value

  const [, countryCode, areaCode, prefix, lineNumber] = parts;
  const formattedNumber = [];

  if (countryCode) {
    formattedNumber.push(`+${countryCode}`);
  }

  if (areaCode) {
    formattedNumber.push(`(${areaCode})`);
  }

  formattedNumber.push(`${prefix}-${lineNumber}`);
  return formattedNumber.join(' ');
}

/**
 * Normalizes the phone number value.
 * Simply strips out anything but digits.
 * This could be expanded to use something like https://github.com/googlei18n/libphonenumber/
 * NOTE: If an extension is included the return format is something like 1234567890,10 where the ',' is the extension separator
 * http://stackoverflow.com/questions/9482633/how-do-i-include-extensions-in-the-tel-uri
 * @param {Object} value The original format value.
 * @param {String} value.number The base phone number (area code, prefix, line number)
 * @param {String|Undefined|Null} value.extension The number extension.
 * @returns {String} The normalized value.
 */
export const normalizeValue = (value) => {
  const stringValues = Object.values(value).filter(val =>
    val !== null && val !== undefined
  ).map(val=> String(val,''));

  return stringValues.map(function(val) {
    return val.match(/\d*/g).reduce(function(acc, digit) {
      return acc + digit;
    }, '');
  }).join(',');
}
export default {
  components: {FromContactSubType },
  mixins: [editMixin],
  computed: {
    answered(){ return (this.answer.data.number||'').length > 0 },
  },
  created () {
    cacheAngularAnswers(this)
  },
  methods:{
    handleChange(){
      this.field.from_cst = false
      this.processValue()

      this.setValidity()
      this.onUpdate(this.field)
      handleFocusOnChange(this, this.routeParams)
      this.handleFocusOut()
    },
    handleFocus(){
      handleFocus(this, this.routeParams)
    },
    handleFocusOut(){
      handleFocusOut(this, this.routeParams)
    },
    setValidity(){
      this.field.answered = this.answered
    },
    setPresentationValue(){
      this.answer.data.number = this.answer.data.presentation_value;
    },
    processValue(){
      const normalizedValue = normalizeValue({
        number: this.answer.data.number,
        extension: this.answer.data.extension
      })
      this.answer.data.normalized_value = normalizedValue;
      this.answer.data.presentation_value = presentationValue(normalizedValue);
    },
    onAnswerChange(){
      this.processValue()
      this.setPresentationValue()
    },
  }
}
</script>